<template>
  <div class="analytics-page">
    <component :is="currentHeader" />
    <div class="profile-content">
      <component :is="currentComponent" />
    </div>
    <component :is="currentFooter" />
  </div>
</template>

<script>
import MobileHeader from "@/components/layouts/mobile/MobileHeader.vue";
import MainHeader from "@/components/layouts/MainHeader.vue";
import MobileFooter from "@/components/layouts/mobile/MobileFooter.vue";
import MainFooter from "@/components/layouts/Footer.vue";
import Breadcrumb from "@/components/layouts/BreadcrumbComponent.vue";
import TabletFooter from "@/components/layouts/tablet/TabletFooter.vue";

export default {
  name: "AnalyticsPage",
  components: {
    MobileHeader,
    MainHeader,
    MobileFooter,
    TabletFooter,
    MainFooter,
    Breadcrumb,
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  computed: {
    currentHeader() {
      return window.innerWidth <= 744 ? "MobileHeader" : "MainHeader";
    },
    currentFooter() {
      const screenWidth = window.innerWidth;
      if (screenWidth > 375 && screenWidth <= 744) {
        return "TabletFooter";
      } else if (screenWidth <= 375) {
        return "MobileFooter";
      } else {
        return "MainFooter";
      }
    },
  },
  mounted() {
    this.updateProfileComponent();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.updateProfileComponent();
    },
    updateProfileComponent() {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 375) {
        import("@/components/profile/mobile/UserProfilePhone.vue").then((module) => {
          this.currentComponent = module.default;
        });
      } else {
        import("@/components/profile/web/UserProfile.vue").then((module) => {
          this.currentComponent = module.default;
        });
      }
    },
  },
};
</script>

<style scoped>
.profile-content {
  padding-left: 108px;
  padding-right: 108px;
}

@media screen and (max-width: 744px) {
  .profile-content {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media screen and (max-width: 375px) {
  .profile-content {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
